import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "24px 40px",
    minHeight: "calc(100vh - 200px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    maxWidth: 500,
    width: "100%",
    textAlign: "center",
    padding: 40,
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#fff",
  },
  icon: {
    fontSize: 80,
    color: "#00897b",
    marginBottom: 24,
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: "#333",
    marginBottom: 16,
  },
  message: {
    fontSize: 16,
    color: "#666",
    marginBottom: 32,
    lineHeight: 1.6,
  },
  button: {
    height: 48,
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: "#00897b",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#00796b",
    },
  },
}));
